/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'

// import store from "@/store/store";

import firebase from 'firebase/app'
import 'firebase/auth'

// import { DEFAULT_LANG } from "@/constants";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // eslint-disable-next-line
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: () => {
            if (localStorage.getItem('userRole') == 'ROLE_CONTRACTOR') {
              return '/installationAccessories'
            } else {
              return '/dashboard'
            }
          },
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/DashboardVessel.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/monitoring',
          name: 'monitoring',
          component: () => import('./views/Monitoring.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/compare',
          name: 'compareVessel',
          component: () => import('./views/CompareVessel.vue'),
          meta: {
            rule: 'hasRoleObserb',
          }
        },

        // =============================================================================
        // Settings Routes
        // =============================================================================
        {
          path: '/settings/users',
          name: 'users',
          component: () => import('./views/settings/UserListView.vue'),
          meta: {
            rule: 'hasRoleAdmin',
          },
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./views/settings/SettingsIndex.vue'),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },
        // =============================================================================
        // Registration
        // =============================================================================
        // {
        //   path: "/registration",
        //   name: "register_persons",
        //   component: () => import("@/views/registration/Register.vue"),
        // },
        // {
        //   path: "/registration/owner/register",
        //   name: "owner_register",
        //   component: () =>
        //     import("@/views/registration/Owner/OwnerRegister.vue"),
        //   meta: {
        //     rule: "hasRoleAdmin",
        //   },
        // },
        // {
        //   path: "/registration/owner/edit",
        //   name: "owner_register",
        //   component: () => import("@/views/registration/Owner/OwnerEdit.vue"),
        //   meta: {
        //     rule: "hasRoleAdmin",
        //   },
        // },
        {
          path: '/registration/owner/profile',
          name: 'owner_register',
          component: () => import('@/views/registration/Owner/OwnerProfile.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/registration/juristic/register',
          name: 'juristic_register',
          component: () =>
            import('@/views/registration/Juristic/JuristicRegister.vue'),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },
        {
          path: '/registration/juristic/edit',
          name: 'juristic_register',
          component: () => import('@/views/registration/Juristic/JuristicEdit.vue'),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },
        {
          path: '/registration/juristic/profile',
          name: 'juristic_register',
          component: () =>
            import('@/views/registration/Juristic/JuristicProfile.vue'),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },
        // =============================================================================
        // Vessel Management
        // =============================================================================
        {
          path: '/vessel',
          name: 'vessel',
          component: () =>
            import('./views/registrationVessel/admin/VesselIndex.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/vessel/registration-vessel',
          name: 'registrationVessel',
          component: () =>
            import('./views/registrationVessel/admin/RegistrationVessel.vue'),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },
        {
          path: '/vessel/detail/:id',
          name: 'vessel_detail',
          component: () =>
            import('./views/registrationVessel/admin/vesselDetail.vue'),
          meta: {
            rule: 'hasRoleContractor', //hasRoleObserb
          },
        },
        {
          path: '/vessel/edit/:id',
          name: 'vessel_edit',
          component: () => import('./views/registrationVessel/admin/EditVessel.vue'),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },

        // =============================================================================
        // Users Management
        // =============================================================================

        {
          path: '/users',
          name: 'users',
          component: () =>
            import('./views/registrationUser/admin/RegistrationIndex.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/users/registration-admin',
          name: 'registrationAdmin',
          component: () =>
            import('./views/registrationUser/admin/RegistrationAdmin.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/users/registration-contractor',
          name: 'RegistrationIndexContractor',
          component: () =>
            import('./views/registrationUser/admin/RegistrationContractor.vue'),
          meta: {
            rule: 'hasRoleAdmin',
          },
        },
        {
          path: '/users/team-contractor',
          name: 'TeamContractor',
          component: () =>
            import('./views/registrationUser/admin/TeamContractor.vue'),
          meta: {
            rule: 'hasRoleAdmin',
          },
        },
        {
          path: '/users/registration-users',
          name: 'registrationUser',
          component: () =>
            import('./views/registrationUser/admin/RegistrationUser.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/users/juristic-detail/:id',
          name: 'juristicDetail',
          component: () =>
            import(
              './views/registrationUser/admin/registrationUser/Juristic/JuristicDetail.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/users/owner-detail/:id',
          name: 'ownerDetail',
          component: () =>
            import(
              './views/registrationUser/admin/registrationUser/Owner/OwnerDetail.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/users/juristic-edit/:id',
          name: 'juristicDetail',
          component: () =>
            import(
              './views/registrationUser/admin/registrationUser/Juristic/JuristicEdit.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/users/owner-edit/:id',
          name: 'ownerDetail',
          component: () =>
            import(
              './views/registrationUser/admin/registrationUser/Owner/OwnerEdit.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/admin/observe-edit/:id',
          name: 'observe_edit',
          component: () =>
            import(
              './views/registrationUser/admin/registrationAdmin/ObserveEdit.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/admin/super-visor-edit/:id',
          name: 'suervisor_edit',
          component: () =>
            import(
              './views/registrationUser/admin/registrationAdmin/SuperVisorEdit.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/admin/admin-detail/:id',
          name: 'adminDetail',
          component: () =>
            import(
              './views/registrationUser/admin/registrationAdmin/AdminDetail.vue'
            ),
          meta: {
            rule: 'hasRoleSuperVisor',
          },
        },
        {
          path: '/admin/admin-edit/:id',
          name: 'adminEdit',
          component: () =>
            import('./views/registrationUser/admin/registrationAdmin/AdminEdit.vue'),
          meta: {
            rule: 'hasRoleAdmin',
          },
        },

        // =============================================================================
        // Reparation
        // =============================================================================
        {
          path: '/reparation',
          name: 'reparation',
          component: () => import('./views/reparation/admin/reparationIndex.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        // =============================================================================
        // Resignation
        // =============================================================================

        {
          path: '/resignation',
          name: 'resignation',
          component: () => import('./views/resignation/admin/ResignationIndex.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        // =============================================================================
        // Notification Accessories (แจ้งรับอุปกรณ์)
        // =============================================================================

        {
          path: '/accessories',
          name: 'Accessories',
          component: () => import('./views/notificationAccessories/notifyIndex.vue'),
          meta: {
            rule: 'hasRoleContractor', //hasRoleSuperVisor
          },
        },

        // =============================================================================
        // Installation Accessories (ติดตั้งอุปกรณ์)
        // =============================================================================

        {
          path: '/installationAccessories',
          name: 'InstallationAccessories',
          component: () =>
            import(
              './views/installationAccessories/installationAccessoriesIndex.vue'
            ),
          meta: {
            rule: 'hasRoleContractor', //hasRoleSuperVisor
          },
        },

        // =============================================================================
        // oil_transfers
        // =============================================================================

        {
          path: '/oil_transfers',
          name: 'OilTransfer',
          component: () => import('./views/oilTransfer/OilTransferDashboard.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_transfer/refinery',
          name: 'RefineryOilTransfer',
          component: () => import('./views/oilTransfer/RefineryOilTransfer.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_transfer/tanker',
          name: 'TankerOilTransfer',
          component: () => import('./views/oilTransfer/TankerOilTransfer.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_transfer/forward_tanker',
          name: 'ForwardTankerOilTransfer',
          component: () =>
            import('./views/oilTransfer/ForwardTankerOilTransfer.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_transfer/vessel',
          name: 'VesselOilTransfer',
          component: () => import('./views/oilTransfer/VesselOilTransfer.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },

        // =============================================================================
        // refuelReport (รายงานการเติมน้ำมัน)
        // =============================================================================

        // {
        //   path: "/refuel_report/ais_loss",
        //   name: "AisLoss",
        //   component: () => import("./views/refuelReport/aisLoss.vue"),
        //   meta: {
        //     rule: "hasRoleCenter",
        //   },
        // },
        {
          path: '/refuel_report/battery_status',
          name: 'BatteryStatus',
          component: () => import('./views/refuelReport/batteryStatus.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/refuel_report/refuel_event',
          name: 'RefuelEvent',
          component: () => import('./views/refuelReport/refuelEvent.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },

        // =============================================================================
        // Profiles Routes
        // =============================================================================
        {
          path: '/settings/me/:id',
          name: 'me',
          component: () => import('./views/settings/Me.vue'),
          meta: {
            rule: 'hasRoleOnlySuperVisor',
          },

          // meta: {
          // breadcrumb: [
          //     { title: 'Home', url: '/' },
          //     { title: 'Users', url: '/settings/users' },
          //     { title: 'My Profile', active: true },
          // ],
          // pageTitle: 'My Profile',
          // rule: 'hasRoleAdmin'
          // }
        },
        {
          path: '/settings/profile-edit/:id',
          name: 'profile-edit',
          component: () => import('./views/settings/EditProfile.vue'),
          meta: {
            rule: 'hasRoleOnlySuperVisor',
          },
        },
        // =============================================================================
        // Notifications
        // =============================================================================

        {
          path: '/notifications',
          name: 'Notifications',
          component: () => import('./views/notifications/notification.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/guard-zone-notification',
          name: 'GuardZoneNotification',
          component: () => import('./views/notifications/guardZoneNotification.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },

        // =============================================================================
        // vesselTrackingReport
        // =============================================================================
        {
          path: '/vesselTrackingReport',
          name: 'vessel_tracking_report',
          component: () => import('@/views/vesselTrackingReport/vesselTracking.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        //vesselOwnerList
        {
          path: '/ownerList',
          name: 'vessel_owner_list',
          component: () =>
            import('./views/registrationVessel/admin/VesselOwnerList.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        // =============================================================================
        // PDSS
        // =============================================================================
        {
          path: '/pdss/greenOil',
          name: 'greenOil',
          component: () => import('@/views/pdss/Home.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/pdss/domesticOil',
          name: 'domesticOil',
          component: () => import('@/views/pdss/Domestic.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/pdss/exportOil',
          name: 'exportOil',
          component: () => import('@/views/pdss/Export.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/pdss/fisheries',
          name: 'fisheriesOil',
          component: () => import('@/views/pdss/Fisheries.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },

        // =============================================================================
        // oilDistribution
        // =============================================================================
        {
          path: '/oil_distribution/refinery',
          name: 'RefineryOilDistribution',
          component: () =>
            import('./views/oilDistribution/RefineryOilDistribution.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_distribution/forward_tanker',
          name: 'ForwardTankerOilDistribution',
          component: () =>
            import('./views/oilDistribution/ForwardTankerOilDistribution.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_distribution/tanker',
          name: 'TankerOilDistribution',
          component: () =>
            import('./views/oilDistribution/TankerOilDistribution.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_distribution/vessel',
          name: 'VesselOilDistribution',
          component: () =>
            import('./views/oilDistribution/VesselOilDistribution.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },

        // =============================================================================
        // Behavior
        // =============================================================================
        {
          path: '/behavior/over_flow_transfer',
          name: 'OverflowTransfer',
          component: () => import('./views/behavior/OverflowTransfer.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/behavior/monthly_occurrence',
          name: 'MonthlyOccurrence',
          component: () => import('./views/behavior/MonthlyOccurrence.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },

        // =============================================================================
        // Pages Routes MonthlyOccurrence
        // =============================================================================
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/registration',
          name: 'register_persons',
          component: () => import('@/views/registration/Register.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/callback',
          name: 'authCallback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/login',
          name: 'pageLogin',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },

        {
          path: '/pages/register',
          name: 'pageRegister',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/forgot-password',
          name: 'pageForgotPassword',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/reset-password/:resetToken',
          name: 'pageResetPassword',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/not-authorized',
          name: 'pageNotAuthorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/emailNotVerified',
          name: 'pageEmailNotVerified',
          component: () => import('@/views/pages/EmailNotVerified.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/emailVerified',
          name: 'pageEmailVerified',
          component: () => import('@/views/pages/EmailVerified.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/passwordChangeDone',
          name: 'pagePasswordChangeDone',
          component: () => import('@/views/pages/PasswordChangeDone.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/pages/passwordChangeError',
          name: 'pagePasswordChangeError',
          component: () => import('@/views/pages/PasswordChangeError.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },

        // =================================================
        // RegisterPrintPDF
        {
          path: '/vessel/pdf',
          name: 'vessel_pdf',
          component: () =>
            import('@/views/registrationVessel/admin/print/RegisterPrintPDF.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/detail/print/:id',
          name: 'vessel_detail_print',
          component: () =>
            import('@/views/registrationVessel/admin/VesselDetailPrint.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/reparation/install/print/:id',
          name: 'reparation_install_print',
          component: () => import('@/views/reparation/print/PrintInstall.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/reparation/notify/print/:id',
          name: 'reparation_notify_print',
          component: () => import('@/views/reparation/print/PrintNotify.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/reparation/receive/print/:id',
          name: 'reparation_receive_print',
          component: () => import('@/views/reparation/print/PrintReceive.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/register/print/:id',
          name: 'vessel_register_print',
          component: () =>
            import('@/views/registrationVessel/admin/print/RegisterPrint.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/receive/print/:id',
          name: 'vessel_receive_print',
          component: () =>
            import('@/views/registrationVessel/admin/print/ReceivedPrint.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/install/print/:id',
          name: 'vessel_install_print',
          component: () =>
            import('@/views/registrationVessel/admin/print/InstallPrint.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/ps05081/print/:id',
          name: 'ps05081',
          component: () =>
            import('@/views/registrationVessel/admin/print/Ps05081.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/ps05082/print/:id',
          name: 'ps05082',
          component: () =>
            import('@/views/registrationVessel/admin/print/Ps05082.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/ps0508-a/print/:id',
          name: 'ps0508-a',
          component: () =>
            import('@/views/registrationVessel/admin/print/Ps0508A.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/ps0508-b/print/:id',
          name: 'ps0508-b',
          component: () =>
            import('@/views/registrationVessel/admin/print/Ps0508B.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },

        // resignation
        {
          path: '/vessel/resign-pdf',
          name: 'vessel_resign_pdf',
          component: () => import('@/views/resignation/print/ResignPrintPDF.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/vessel/resignation/print/:id',
          name: 'vessel_resignation_print',
          component: () => import('@/views/resignation/print/ResignationPrint.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },

        // Oil transfer
        {
          path: '/oil_transfer/print',
          name: 'oil_transfer_print',
          component: () => import('@/views/oilTransfer/print/printOilTransfer.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        // vesselTrackingReport
        {
          path: '/vesselTrackingReport/print',
          name: 'vessel_tracking_report_print',
          component: () =>
            import(
              '@/views/vesselTrackingReport/print/printVesselTrackingReport.vue'
            ),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        //oilDistribution
        {
          path: '/oil_distribution/print/refinery',
          name: 'PrintRefineryOilDistribution',
          component: () =>
            import('@/views/oilDistribution/print/PrintRefineryOilDistribution.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/oil_distribution/print/refineries',
          name: 'PrintRefineriesOilDistribution',
          component: () =>
            import('@/views/oilDistribution/print/PrintRefineriesOilDistribution.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/oil_transfer/print/vessel',
          name: 'PrintVesselOilDistribution',
          component: () =>
            import('@/views/oilDistribution/print/PrintVesselOilTransfer.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/behavior/monthly_occurrence/refinery',
          name: 'MonthlyOccurrenceRefinery',
          component: () => import('./views/behavior/print/PrintRefinery.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/behavior/monthly_occurrence/forward_tanker',
          name: 'MonthlyOccurrenceForwardTanker',
          component: () => import('./views/behavior/print/PrintForwardTanker.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/behavior/monthly_occurrence/tanker',
          name: 'MonthlyOccurrenceTanker',
          component: () => import('./views/behavior/print/PrintTanker.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/behavior/monthly_occurrence/vessel',
          name: 'MonthlyOccurrenceVessel',
          component: () => import('./views/behavior/print/PrintVessel.vue'),
          meta: {
            rule: 'hasRoleObserb',
          },
        },
        {
          path: '/train-tracking',
          name: 'trainTracking',
          component: () => import('./views/TrainTracking.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404',
    },



    // =============================================================================
    // FLOW METER
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/flowMeter/index.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/flow-meter',
          name: 'flowMeter',
          component: () => import('./views/flowMeter/Dashborad.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/flow-meter/oil-transfers',
          name: 'oilTransfers',
          component: () => import('./views/flowMeter/OilTransfers.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
        {
          path: '/flow-meter/monitoring',
          name: 'monitoring',
          component: () => import('./views/flowMeter/Monitoring.vue'),
          meta: {
            rule: 'hasRoleViewer',
          },
        },
      ],
    },

  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (
    to.path === '/pages/login' ||
    to.path === '/pages/forgot-password' ||
    to.path.indexOf('/pages/reset-password') > -1 || // because it is /pages/reset-password/{token}
    to.path === '/pages/error-404' ||
    to.path === '/registration' ||
    to.path === '/settings' ||
    to.path === '/pages/not-authorized' ||
    to.path === '/pages/emailNotVerified' ||
    to.path === '/pages/emailVerified' ||
    to.path === '/pages/passwordChangeDone' ||
    to.path === '/pages/passwordChangeError' ||
    to.path === '/callback' ||
    to.path === '/vessel/ps0508-a/print/:id' ||
    to.path === '/train-tracking' ||
    to.path === '/flow-meter' ||
    to.path === '/flow-meter/oil-transfers' ||
    to.path === '/flow-meter/monitoring' ||
    localStorage.accessToken
  ) {
    if (localStorage.accessToken && to.path === '/pages/login') {
      router.push({ path: '/dashboard' })
    }
    return next()
  }
  router.push({ path: '/pages/login' })
  // router.push({ path: "/dashboard" });

  return next()
})
export default router
